/* unplugin-vue-components disabled */import script from "./GpTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GpTable.vue?vue&type=script&setup=true&lang=ts"

import "./GpTable.vue?vue&type=style&index=0&id=7891cd78&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7891cd78"]])

export default __exports__